<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "AuctionFilter" });
import { QUERY_STATE } from "../../../../stores/query.js";
import AuctionList from "../list/AuctionList.svelte";
import Form from "../../../../components/form/Form.svelte";
import Pagination from "../../../../components/pagination/Pagination.svelte";
import { onDestroy, onMount, getContext } from "svelte";
export let defaults;
export let showPagination = true;
const SCOPE = getContext("scope");
let parameters = null;
let unsubscribeParameters;
let ListComponent = null;
onMount(() => {
    QUERY_STATE.registerScope(SCOPE, defaults);
    unsubscribeParameters = QUERY_STATE.subscribeScope(SCOPE, (data) => {
        parameters = { ...data };
    });
});
onDestroy(() => {
    QUERY_STATE.unregisterScope(SCOPE);
    unsubscribeParameters();
});
</script>

{#if parameters !== null}

    <Form id = 'filter-auctions' align = 'horizontal'>
        <slot name = 'form' { parameters } />
    </Form>

    {#if showPagination}
        <Pagination count = { ListComponent?.COUNT }/>
    {/if}

    <AuctionList { parameters } let:auctions bind:this = { ListComponent }>

        <slot { auctions }>
            <pre>{ JSON.stringify(auctions, null, 4) }</pre>
        </slot>

        <svelte:fragment slot = 'empty'>
            <slot name = 'empty' />
        </svelte:fragment>

    </AuctionList>

{/if}